<template>
  <div class="step-nav-wrapper">
    <button @click="previousPage()" class="d-none d-md-block nav-button prevStep">{{ $t(`pageContent.buttons.prev`)}}</button>
    <button v-if="thisPage !== '9'" :key="`thisPage_`+ thisPage +`_`+disabled"
            class="d-none d-md-block nav-button nextStep" :class="{disabled : isDisabled()}"
            :disabled="disabled" @click="nextPage()" >{{ $t(`pageContent.buttons.next`)}}</button>
    <button v-if="thisPage === '8'"
            class="d-none d-md-block nav-button nextStep"
            @click="nextPage()" >{{ $t(`pageContent.buttons.next`)}}</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StepNavi',
  computed: {
    ...mapGetters([
      'currentPageNumber',
      'currentPage',
      'allowStepUpTo',
      'calculatorPages'
    ])
  },
  props: {
    thisPage: String
  },
  data () {
    return {
      disabled: true
    }
  },
  methods: {
    isDisabled: function () {
      if (this.calculatorPages[this.currentPageNumber + 1]) {
        this.disabled = this.calculatorPages[this.currentPageNumber + 1].disabled
        return this.disabled
      }
    },
    increaseTab: function () {
      var current = this.$store.state.calculatorData.currentPageNumber
      this.$store.commit('setCurrentPageNumber', parseInt(current) + 1)
      if (!isNaN(parseInt(current))) {
        if (current < 8) {
          // this.setLocationHash(parseInt(current) + 1)
        } else if (parseInt(current) === 8) {
          // this.setLocationHash('kontakt')
        }
      }
    },
    nextPage: function () {
      this.$store.commit('incrementPage')
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (rootApp && typeof rootApp.updateCurrentTab === 'function') {
        rootApp.updateCurrentTab()
      }
      this.registerUserInput()
      this.trackingButton('Weiter')
    },
    previousPage: function () {
      if (this.thisPage === 'contact') {
        const contactPageNumber = 9
        const newPageNumber = ((this.allowStepUpTo + 1) < contactPageNumber) ? (this.allowStepUpTo + 1) : contactPageNumber
        this.$store.commit('setCurrentPageNumber', newPageNumber)
      }
      this.$store.commit('decrementPage')
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (rootApp && typeof rootApp.updateCurrentTab === 'function') {
        rootApp.updateCurrentTab()
      }
      this.registerUserInput()
      this.trackingButton('Zurück')
    },
    trackingButton: function (type) {
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (!rootApp) return
      
      let virtualPageURL = ''
      let virtualPageTitle = ''
      if (rootApp.currentPageNumber === 9) {
        virtualPageURL = '/' + this.$t('contact.virtualPageURL')
        virtualPageTitle = this.$t('contact.virtualPageTitle')
      } else if (rootApp.currentPage && rootApp.currentPage.headline) {
        virtualPageURL = '/' + this.$t(rootApp.currentPage.headline + '.virtualPageURL')
        virtualPageTitle = this.$t(rootApp.currentPage.headline + '.virtualPageTitle')
      }
      if (typeof rootApp.globalGTMFkt === 'function') {
        rootApp.globalGTMFkt('JKK-Events', 'Navigation', 'Pfeil Navigation', type, '', virtualPageURL, virtualPageTitle)
      }
    },
    registerUserInput: function () {
      // this line needs to track only User Input
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (rootApp) {
        rootApp.userDidAction = true
      }
    }
  },
  mounted: function () {
    // console.log('--- StepNavi rendert ---')
    this.isDisabled()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.step-nav-wrapper{
  position: relative;
  display: block;
  height: 78px;
  margin-top: 2rem;
}

.insulationMaterial .prevStep{
  display: none !important;
}

.contact .nextStep{
  display: none !important;
}

</style>
